import * as React from "react";
import { appContext } from "../App/appContext" 

import {
    ILoaderProps, FeltErrors, ILoaderState, IModelLaster, FeltError, IRouteComponent, objectEquals, spinnerDelayMs
} from "../domene"

import { ModelLaster } from "./ModelLaster";

export abstract class RouteComponent extends React.Component<ILoaderProps, ILoaderState> implements IRouteComponent {

    readonly laster: IModelLaster;
    private mounted = false;
    private errors: FeltErrors = {};

    protected constructor(props: ILoaderProps) {
        super(props);
        this.laster = props.laster || new ModelLaster(this);
        this.updateState();
    }

    createState(): ILoaderState {
        return {
            resources: this.props.laster ? {} : Object.assign({}, this.laster.resources),
            errors: Object.assign({}, this.errors)
        }
    }

    updateState(): void {
        if(this.mounted) {
            //appContext.log("updateState mounted");
            this.setState(this.createState());
        } else {
            //appContext.log("updateState not mounted");
            this.state = this.createState();
        }
    }

    componentWillReceiveProps() {
        if(!this.props.laster) {
            this.laster.removeHandlers();
            this.errors = {};
            this.updateState();
        }
    }

    componentDidMount() {
        //appContext.log("RouteComponent did mount");
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
        if(!this.props.laster) {
            this.laster.removeHandlers();
        }
    }

    setErrors(errors: FeltError[]): void {
        const oldErrors = this.errors;
        this.errors = {};
        errors.forEach(error => this.errors[error.felt || ""] = error.melding);
        if(!objectEquals(oldErrors, this.errors)) {
            this.updateState();
        }
    }

    setError(key: string, error: string | undefined) {
        const oldError = this.errors[key];
        if (error) {
            this.errors[key] = error;
        } else {
            delete this.errors[key];
        }
        if(oldError !== error) {
            this.updateState();
        }
    }

    handleError(felt: string | undefined, error: Gf.Web.Models.ApiError): void {
        this.setErrors([new FeltError(felt, (error ? error.Message : undefined) || "Det oppsto en ukjent feil")]);
    }

    getError(key: string): string | undefined {
        return this.errors[key];
    }

    getErrors(): FeltError[] {
        return Object.getOwnPropertyNames(this.errors)
            .map(key => new FeltError(key, this.errors[key]));
    }

    protected abstract renderPossiblyNotLoaded(): JSX.Element | null;

    render() {
        const result = this.renderPossiblyNotLoaded();
        const loadingSince = this.laster.loadingSince();
        if (!loadingSince) {
            this.afterLoading();
        }
        const spinnerTime = loadingSince === null ? null : new Date(loadingSince.getTime() + spinnerDelayMs);
        const now = new Date();
        const spinnerNow = !!spinnerTime && spinnerTime < now;

        const spinner = !!spinnerTime && !this.props.laster;
        if (!spinner) {
            return <div>{result}</div>;
        }
        const spinnerClass = spinnerNow ? "" : "hidden";
        if (spinnerRevealHandle) {
            clearTimeout(spinnerRevealHandle);
        }
        if (!spinnerNow && !!spinnerTime) {
            spinnerRevealHandle = setTimeout(() => {
                const elem = document.getElementById("spinnerWrapper");
                if (elem) {
                    elem.className = "";
                }
            }, spinnerTime.getTime() - now.getTime());
        }
        return <div>{result}<div id="spinnerWrapper" className={spinnerClass}><div className="darkPage"></div><div className="spinner">
                                           <div className="double-bounce1"></div>
                                           <div className="double-bounce2"></div>
                                       </div></div></div>;
    }

    // Will be called after loading
    protected afterLoading() {}
}

let spinnerRevealHandle: number | null = null;



// WEBPACK FOOTER //
// ./Scripts/React/Component/RouteComponent.tsx